module.exports = __webpack_public_path__ + "img/ac917bb.png";